window.getScrollbarWidth = function () {
	var viewport = $(window),
		outerWidth = viewport.outerWidth(),
		innerWidth = viewport.innerWidth();
	if (outerWidth > innerWidth) {
		return outerWidth - innerWidth;
	} else {
		return 0;
	}
}
window.bodyScrollLock = function () { // not compatible with scroll-behavior: smooth;
	// console.log('lock');
	$('html,body').css({
		position: 'fixed',
		top: '-' + window.scrollY + 'px',
		width: '100%'
	});
	$('body').css('paddingRight', getScrollbarWidth() + 'px');
}
window.bodyScrollUnlock = function () { // not compatible with scroll-behavior: smooth;
	// console.log('unlock');
	$('html,body').css({
		position: 'static'
	});
	let scrollY = $('body').css('top');
	window.scrollTo(0, parseInt(scrollY || '0') * -1);
	$('body').css('paddingRight', '0');
}

